var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionInfoLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-60.000000, -1440.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Info/Large",
    transform: "translate(60.000000, 1440.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,16 C2,23.731 8.268,30 16,30 C23.733,30 30,23.731 30,16 C30,8.268 23.733,2 16,2 C8.268,2 2,8.268 2,16 Z M0,16 C0,7.163 7.163,0 16,0 C24.837,0 32,7.163 32,16 C32,24.836 24.837,32 16,32 C7.163,32 0,24.836 0,16 Z M16,12 C14.8953,12 14,11.1047 14,10 C14,8.89607 14.8953,8 16,8 C17.1047,8 18,8.89607 18,10 C18,11.1047 17.1047,12 16,12 Z M17.648,20.1522 C17.648,21.8191 17.103,23.3314 14.3747,23.3314 L14.3747,14.4549 L17.648,14.4549 L17.648,20.1522 Z",
    id: 338
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionInfoLarge);
export default __webpack_public_path__ + "static/media/navigation-and-action-info-large.c9f5bec7.svg";
export { ForwardRef as ReactComponent };